import { KeyboardEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Dialog, DialogTitle, DialogContent, InputLabel, TextField, DialogActions } from "@mui/material";
import { ModeEditRounded } from "@mui/icons-material";
import { ContentModel } from "../../../shell/services/types";
import { createItem, generateItem } from "../../../shell/store/content";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { useGetContentModelFieldsQuery } from "../../../shell/services/instance";
export const CreateVariantDialog = ({
  onClose,
  model
}: {
  onClose: () => void;
  model: ContentModel;
}) => {
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [variantName, setVariantName] = useState("Untitled");
  const [isLoading, setIsLoading] = useState(false);
  const {
    data: fields,
    isFetching: isFieldsLoading
  } = useGetContentModelFieldsQuery({
    modelZUID: model?.ZUID
  });
  const handleVariantCreate = async () => {
    if (!model?.ZUID) {
      return;
    }
    setIsLoading(true);
    const initialData: {
      [key: string]: any;
    } = fields?.reduce((accu, curr) => {
      if (!curr.deletedAt) {
        accu[curr.name] = curr?.settings?.defaultValue !== null && curr?.settings?.defaultValue !== undefined ? curr?.settings?.defaultValue : null;
      }
      return accu;
    }, {} as {
      [key: string]: any;
    });
    await dispatch(generateItem(model?.ZUID, initialData, {
      metaTitle: variantName
    }));
    const res = await Promise.resolve(dispatch(createItem({
      modelZUID: model.ZUID,
      itemZUID: `new:${model.ZUID}`,
      skipPathPartValidation: true
    })));
    // @ts-ignore
    history.push(`/blocks/${model.ZUID}/${res?.data?.ZUID}`);
    setIsLoading(false);
    onClose();
  };
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      handleVariantCreate();
    }
  };
  return <Dialog open onClose={onClose} fullWidth maxWidth="xs" data-sentry-element="Dialog" data-sentry-component="CreateVariantDialog" data-sentry-source-file="CreateVariantDialog.tsx">
      <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="CreateVariantDialog.tsx">
        <Box sx={{
        backgroundColor: "deepOrange.100",
        borderRadius: "100%",
        width: "40px",
        height: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mb: 1.5
      }} data-sentry-element="Box" data-sentry-source-file="CreateVariantDialog.tsx">
          <ModeEditRounded color="primary" data-sentry-element="ModeEditRounded" data-sentry-source-file="CreateVariantDialog.tsx" />
        </Box>
        {t("blocks.createVariantOf", {
        label: model?.label
      })}
      </DialogTitle>
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="CreateVariantDialog.tsx">
        <InputLabel sx={{
        mb: 0.5
      }} data-sentry-element="InputLabel" data-sentry-source-file="CreateVariantDialog.tsx">{t("blocks.variantName")}</InputLabel>
        <TextField autoFocus value={variantName} onChange={event => setVariantName(event.target.value)} fullWidth data-cy="variant-name-input" onFocus={evt => evt.target.select()} onKeyDown={handleKeyDown} data-sentry-element="TextField" data-sentry-source-file="CreateVariantDialog.tsx" />
      </DialogContent>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="CreateVariantDialog.tsx">
        <Button onClick={onClose} color="inherit" data-sentry-element="Button" data-sentry-source-file="CreateVariantDialog.tsx">
          {t("common.cancel")}
        </Button>
        <Button disabled={isFieldsLoading || !model?.ZUID} onClick={handleVariantCreate} loading={isLoading} variant="contained" data-cy="create-variant-confirm-button" data-sentry-element="Button" data-sentry-source-file="CreateVariantDialog.tsx">
          {t("common.create")}
        </Button>
      </DialogActions>
    </Dialog>;
};